import { memo, type ReactNode } from 'react';

export type MainSideNavItemLabelProps = {
  children: ReactNode;
};

export const MainSideNavItemLabel = memo(({ children }: MainSideNavItemLabelProps) => {
  return (
    <span
      className="relative z-1 min-w-0 max-w-0 overflow-hidden whitespace-nowrap opacity-0 group-has-[[data-state=open]]/main-side-nav:-ml-3 group-has-[[data-state=open]]/main-side-nav:max-w-full group-has-[[data-state=open]]/main-side-nav:flex-1 group-has-[[data-state=open]]/main-side-nav:truncate group-has-[[data-state=open]]/main-side-nav:pr-3 group-has-[[data-state=open]]/main-side-nav:opacity-100 group-data-[hover-expand]/main-side-nav:-ml-3 group-data-[pinned]/main-side-nav:-ml-3 group-data-[hover-expand]/main-side-nav:max-w-full group-data-[pinned]/main-side-nav:max-w-full group-data-[hover-expand]/main-side-nav:flex-1 group-data-[pinned]/main-side-nav:flex-1 group-data-[hover-expand]/main-side-nav:truncate group-data-[pinned]/main-side-nav:truncate group-data-[hover-expand]/main-side-nav:pr-3 group-data-[pinned]/main-side-nav:pr-3 group-data-[hover-expand]/main-side-nav:opacity-100 group-data-[pinned]/main-side-nav:opacity-100"
      data-testid="MAIN_SIDE_NAV_ITEM_LABEL"
    >
      {children}
    </span>
  );
});

MainSideNavItemLabel.displayName = 'MainSideNavItemLabel';
